import React, { useMemo } from 'react'
import { BaseEditorButton } from 'src/editor/shared/entities/base-editor-button'
import {
  FormInterface,
  FormSubmitButtonInterface,
} from 'src/shared/types/entities/form-interface'
import { FormBaseElement } from './form-base-element'

interface FormSubmitButtonProps {
  formEntity: FormInterface
  submitButton: FormSubmitButtonInterface
}

// NOTE: this is a draft
export const FormSubmitButton = ({
  formEntity,
  submitButton,
}: FormSubmitButtonProps) => {
  const entity = useMemo(
    () => ({
      ...submitButton,
      // TODO: add common button props
    }),
    [submitButton],
  )

  return (
    <FormBaseElement
      title={'entity_settings.submit_button.header'}
      formEntity={formEntity}
      element={submitButton}
    >
      <BaseEditorButton entity={entity} />
    </FormBaseElement>
  )
}
